import { isMobile } from '../helpers/isMobile';

export const AnimationConfigs = {
  intro: 'back.in(1.5)',
  loop: 'linear',
  forceStop: 'back.out(2)',
  stopNormal: 'customStopNormal',
  stopFast: 'customStopFast',
  stopTurbo: 'customStopTurbo',
  START_SPEED: -3,
  STOPPING_STEPS: 5,
  REVERSE_STEPS_FAST_MODE: 10,
  REVERSE_STEPS_STANDARD_MODE: isMobile() ? 7 : 10,
};

export const gameGlobalStates = {
  none: 'none',
  show: 'show',
  waiting: 'waiting',
  bonus: 'bonus',
};

export const symbolSizesByGame = {
  225: {
    height: isMobile() ? 102 : 200,
    width: isMobile() ? 102 : 200,
  },
  226: {
    height: isMobile() ? 76.5 : 150,
    width: isMobile() ? 102 : 200,
  },
  227: {
    height: isMobile() ? 76.5 : 150,
    width: isMobile() ? 102 : 200,
  },
  329: {
    height: isMobile() ? 76.5 : 150,
    width: isMobile() ? 102 : 200,
  },
};

export const reelsContainerParamsByGame = {
  225: {
    width: isMobile() ? 534 : 1040,
    height: isMobile() ? 306 : 600,
    xInFigma: isMobile() ? 2 : 200,
    yInFigma: isMobile() ? 256 : 105,
    offsetForContainerBoardWidth: isMobile() ? 1 : 3,
    offsetForContainerBoardHeight: isMobile() ? 1 : 2,
    spacing: isMobile() ? 6 : 10,
  },
  226: {
    width: isMobile() ? 534 : 1040,
    height: isMobile() ? 306 : 600,
    xInFigma: isMobile() ? 2 : 200,
    yInFigma: isMobile() ? 252 : 105,
    offsetForContainerBoardWidth: isMobile() ? 1 : 4,
    offsetForContainerBoardHeight: isMobile() ? 1 : 2,
    spacing: isMobile() ? 6 : 10,
  },
  227: {
    width: isMobile() ? 534 : 1040,
    height: isMobile() ? 306 : 600,
    xInFigma: isMobile() ? 2 : 200,
    yInFigma: isMobile() ? 252 : 105,
    offsetForContainerBoardWidth: isMobile() ? 1 : 4,
    offsetForContainerBoardHeight: isMobile() ? 1 : 2,
    spacing: isMobile() ? 6 : 10,
  },
  329: {
    width: isMobile() ? 534 : 1040,
    height: isMobile() ? 306 : 600,
    xInFigma: isMobile() ? 2 : 200,
    yInFigma: isMobile() ? 252 : 105,
    offsetForContainerBoardWidth: isMobile() ? 1 : 4,
    offsetForContainerBoardHeight: isMobile() ? 1 : 2,
    spacing: isMobile() ? 6 : 10,
  },
};

export const reelParamsByGame = {
  225: {
    reelParams: {
      visibleRows: 3,
      iconsInReel: 9,
      iconsHeight: isMobile() ? 102 : 200,
      iconsWidth: isMobile() ? 102 : 200,
      finalPositionX: 0,
      finalPositionY: 0,
      iconsSpacing: 0.5,
      spacing: isMobile() ? 6 : 10,
      iconMargins: { default: 98 },
      offsetForContainerBoardWidth: isMobile() ? 0 : 0,
      speedDuration: 0.35,
      iconsFinalPositions: {
        inWinContainer: [],
        inReel: [],
      },
    },
    reelsCount: 5,
  },
  226: {
    reelParams: {
      visibleRows: 4,
      iconsInReel: 12,
      iconsHeight: isMobile() ? 76.5 : 150,
      iconsWidth: isMobile() ? 102 : 200,
      finalPositionX: 0,
      finalPositionY: 0,
      iconsSpacing: 0,
      spacing: isMobile() ? 6 : 10,
      offsetForContainerBoardWidth: isMobile() ? 0 : 0,
      speedDuration: 0.35,
      iconsFinalPositions: {
        inWinContainer: [],
        inReel: [],
      },
    },
    reelsCount: 5,
  },
  227: {
    reelParams: {
      visibleRows: 4,
      iconsInReel: 12,
      iconsHeight: isMobile() ? 76.5 : 150,
      iconsWidth: isMobile() ? 102 : 200,
      finalPositionX: 0,
      finalPositionY: 0,
      iconsSpacing: 0,
      spacing: isMobile() ? 6 : 10,
      offsetForContainerBoardWidth: isMobile() ? 0 : 0,
      speedDuration: 0.35,
      iconsFinalPositions: {
        inWinContainer: [],
        inReel: [],
      },
    },
    reelsCount: 5,
  },
  329: {
    reelParams: {
      visibleRows: 4,
      iconsInReel: 12,
      iconsHeight: isMobile() ? 76.5 : 150,
      iconsWidth: isMobile() ? 102 : 200,
      finalPositionX: 0,
      finalPositionY: 0,
      iconsSpacing: 0,
      spacing: isMobile() ? 6 : 10,
      offsetForContainerBoardWidth: isMobile() ? 0 : 0,
      speedDuration: 0.35,
      iconsFinalPositions: {
        inWinContainer: [],
        inReel: [],
      },
    },
    reelsCount: 5,
  },
};
